/*
type Team = {
  owner: string;
  coach?: string;
  players: Player[];
}

TODO:
if a team doesn't have a coach, they will be assigned a former Cavs coach.

type Player = {
  name: string;
  year: string;
}
*/

import React from "react";
import Roster from "../roster/roster";

import styles from "./team.module.css";

const randomCoach = () => {
  const { random, floor } = Math;
  const sample = (arr) => arr[floor(random() * arr.length)];

  return sample([
    "John Beilein",
    // "Jim Boylen",
    // "Bob Kloppenburg",
    // "David Blatt",
    // "Kiki Vandeweghe",
  ]);
};

const Team = ({ team }) => {
  return team ? (
    <>
      <h2>{team.owner}</h2>
      <div>Coach: {team.coach || randomCoach() + " (randomly assigned)"}</div>
      <Roster players={team.players} />
    </>
  ) : (
    <p className={styles.tbd}>TBD</p>
  );
};

export default Team;
